module.exports = __webpack_public_path__ + "res/bingo.bfad3c6684308733e1668d7dd2172110.webp";